import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { fetchPublicCard, type PublicLoyaltyCard } from '../services/loyalty'
import { formatTRY } from '../utils/money'
import { CheckIcon, HeartIcon } from '../components/icons'
import './LoyaltyCardPage.css'

/**
 * Müşterinin sadakat kartı (30 Eki 2026): kasada açılan kartın karekodundan
 * gelir, girişsiz. Adres tahmin edilemez token taşıyor; başkasının kartı
 * görünmez (supabase/sadakat.sql loyalty_card_public).
 */
export function LoyaltyCardPage() {
  const { token = '' } = useParams()
  const [card, setCard] = useState<PublicLoyaltyCard | null | undefined>(undefined)

  useEffect(() => {
    let alive = true
    fetchPublicCard(token)
      .then((c) => alive && setCard(c))
      .catch(() => alive && setCard(null))
    return () => {
      alive = false
    }
  }, [token])

  if (card === undefined) return <div className="lcard lcard--wait" />
  if (card === null) {
    return (
      <div className="lcard">
        <div className="lcard__box">
          <h1>Kart bulunamadı</h1>
          <p className="lcard__muted">Bağlantı hatalı ya da kart artık geçerli değil. Kasaya sorabilirsiniz.</p>
        </div>
      </div>
    )
  }

  const full = card.stamps >= card.target
  const left = Math.max(0, card.target - card.stamps)
  const rule = card.per === 'amount' ? `Her ${formatTRY(card.amountKurus)} harcamaya 1 damga` : 'Her ödemede 1 damga'

  return (
    <div className="lcard">
      <div className="lcard__box">
        <p className="lcard__biz">{card.business}</p>
        <h1>Sadakat kartınız</h1>
        {card.name && <p className="lcard__muted">{card.name}</p>}

        <div className="lcard__stamps" aria-label={`${Math.min(card.stamps, card.target)} / ${card.target} damga`}>
          {Array.from({ length: card.target }, (_, i) => (
            <span key={i} className={i < card.stamps ? 'is-on' : ''}>
              {i < card.stamps ? <CheckIcon /> : i === card.target - 1 ? <HeartIcon /> : null}
            </span>
          ))}
        </div>

        <div className={`lcard__status ${full ? 'is-full' : ''}`}>
          {full ? (
            <>
              <b>Ödülünüz hazır!</b>
              <span>Bir sonraki ödemenizde %{card.rewardPercent} indirim. Kasada kodunuzu söyleyin.</span>
            </>
          ) : (
            <>
              <b>
                {Math.min(card.stamps, card.target)} / {card.target} damga
              </b>
              <span>
                {left} damga sonra %{card.rewardPercent} indirim.
              </span>
            </>
          )}
        </div>

        <div className="lcard__code">
          <span>Kasada söyleyeceğiniz kod</span>
          <b>{card.code}</b>
        </div>

        <p className="lcard__muted lcard__rule">{rule}.</p>
        <p className="lcard__muted lcard__tip">Bu sayfayı telefonunuzun ana ekranına ekleyerek kartınıza hemen ulaşabilirsiniz.</p>
      </div>
      <p className="lcard__brand">Adissoo</p>
    </div>
  )
}
